module.exports = __webpack_public_path__ + "static/PP3s-0177cc4c7322ce489180166f20fddb89.jpg";